import { type FC } from 'react'

export const EverGiveToolTipContent: FC = () => {
  return <div className="font-light">
    <p>
    We’re excited to announce that we’ve partnered with <a href='https://www.evergive.com/' target='_blank' className='text-black font-bold underline' rel="noreferrer">EverGive</a> to ensure your donations create an ever lasting impact.
    </p>
    <br />
    <p>
    Your daily donation will remain the same. <span className='font-bold'>This is not an additional payment.</span> When you contribute, the selected percentage of your donation will be invested into Bitcoin, which builds a long term reserve that helps your impact last forever.
    </p>
    <br />
    <p>
    The upside for charities is that they receive a constant stream of monthly grants, providing them a low effort, long-term solution to raising funds where they can be less reliant on fundraising.
    </p>
    <br />
    <p>
    We will only invest the percentage of your donation that you opt into, capped at your non-Zakat funds. <span className='font-bold'>Zakat funds will not be invested.</span>
    </p>
    <br />
    <p>
    By opting in, you agree to
    <a href='https://www.evergive.com/company/policies/privacy-policy' target='_blank' className='text-black font-bold underline' rel="noreferrer"> EverGive privacy policy </a>
    and <a href='https://www.evergive.com/company/policies/terms-and-conditions' target='_blank' className='text-black font-bold underline' rel="noreferrer">terms and conditions</a>.
    </p>
    <br />
    For more information about how EverGive supports charities you can find out more here with their <a href='https://www.evergive.com/#faqs' target='_blank' className='text-black font-bold underline' rel="noreferrer">FAQs</a> and useful insights on the product with their <a href='https://www.evergive.com/blog' target='_blank' className='text-black font-bold underline' rel="noreferrer">Blogs</a>.
</div>
}
